import { render, staticRenderFns } from "./bidOpeningHall.vue?vue&type=template&id=bad3dcfa&scoped=true"
import script from "./bidOpeningHall.vue?vue&type=script&lang=js"
export * from "./bidOpeningHall.vue?vue&type=script&lang=js"
import style0 from "./bidOpeningHall.vue?vue&type=style&index=0&id=bad3dcfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad3dcfa",
  null
  
)

export default component.exports